import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {
    '& .textLayer, & .annotationLayer': { display: 'none !important' },
  },
});

export default useSx;
